import React from "react";
import "../css-coding/FoundersPage.css";
import { FaInstagram, FaLinkedinIn,FaYoutube} from "react-icons/fa";


import prakashRajImage from "../assets/prakash.jpg";


// --- 1. Combined Content for Prakash Raj (Founder & CEO) ---
const prakashBio = (
  <>
    <p>
      Hi, I'm <strong>Prakash Raj, a 24-year-old MBA graduate</strong> with an
      unwavering passion for video editing and visual storytelling. My journey
      into the world of digital content creation began in 2017, and since then,
      I've dedicated myself to mastering the art of video editing and motion
      graphics.
    </p>
    <p>
      With over <strong>4 years of experience</strong> in the industry, I've
      successfully completed <strong>900+ video editing projects for 150+ clients</strong>,
      helping brands tell their stories in the most compelling way possible. My
      expertise spans across <strong>After Effects, Premiere Pro, and DaVinci Resolve</strong>,
      with a special focus on creating retention-driven content that captivates audiences.
    </p>
    <p>
      What truly drives me is my mission to <strong>turn editors into entrepreneurs</strong>.
      Through my personal brand (itsprakashhere), I've built a community of aspiring editors
      and creators. I run educational courses like “To Become the Reels GOAT”
      (Reels Editing Masterclass) , Ultimate Graphic Design Masterclass and After Effects Masterclass, where I teach
      editors how to monetize their skills and build successful careers.
    </p>
  </>
);



// --- 3. Team Members Data ---
const teamMembers = [
  {
    id: 1,
    name: "Prakash Raj",
    role: "Founder & CEO , The Growth Secret Media",
    imgUrl: prakashRajImage,
    bio: prakashBio,

    instagram: "https://www.instagram.com/itsprakashhere_/",  
    linkedin: "https://linkedin.com/in/itsprakashhere",
    youtube: "https://www.youtube.com/@Itsprakashhere",
  },
  
];

// --- 4. Card Component ---
const FounderCard = ({ member }) => {
  return (
    <div className="founder-card">
      <div className="card-top-content">
        <div className="profile-image-container">
          <img
            src={member.imgUrl}
            alt={`Profile of ${member.name}`}
            className="profile-image"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src =
                "https://placehold.co/1200x1200/aaaaaa/333333?text=Profile";
            }}
          />
        </div>
        <div className="profile-details">
          <h3 className="profile-name">{member.name}</h3>
          <p className="profile-role">{member.role}</p>
          {/* Social Icons */}
<div className="social-icons">
  {member.instagram && (
    <a href={member.instagram} target="_blank" rel="noopener noreferrer">
      <FaInstagram />
    </a>
  )}

  {member.linkedin && (
    <a href={member.linkedin} target="_blank" rel="noopener noreferrer">
      <FaLinkedinIn />
    </a>
  )}

    {member.linkedin && (
    <a href={member.youtube} target="_blank" rel="noopener noreferrer">
      <FaYoutube/>
    </a>
  )}
</div>
        </div>
      </div>
      <div className="card-bottom-content">
        <div className="profile-bio-text">{member.bio}</div>
      </div>
    </div>
  );
};

// --- 5. Main Page Component ---
const FounderPage = () => {
  return (
    <div className="team-container">
      <div className="team-header">
        <h2 className="team-title">Meet Our Founder</h2>
      </div>

      <div className="founders-grid">
        {teamMembers.map((member) => (
          <FounderCard key={member.id} member={member} />
        ))}
      </div>
    </div>
  );
};

export default FounderPage;
